export default [
  {
    path: '/keyword-search',
    name: 'keyword-search',
    component: () => import('@/views/keywordSearch/KeywordSearch.vue'),
    meta: {
      clinicianBlocked: true,
      protected: true,
      pageTitle: 'Keywords & Phrases',
      breadcrumb: [
        {
          text: 'Keywords',
          active: true,
        },
      ],
    },
  },
]
